import { Dialog as PrimerDialog } from '@primer/react';
import React from 'react';
import { preventOutsideClose } from './outsideClickGuard';

type PrimerDialogProps = React.ComponentProps<typeof PrimerDialog>;

/**
 * Thay thế cho Dialog của '@primer/react' (bản v1, dùng onDismiss):
 * bấm ra ngoài modal sẽ KHÔNG tự đóng modal (chỉ đóng bằng nút X / nút trong modal / phím Esc).
 */
const SafeDialogBase = (props: PrimerDialogProps) => {
    return <PrimerDialog {...props} onDismiss={preventOutsideClose(props.onDismiss)} />;
};

const SafeDialog = Object.assign(SafeDialogBase, { Header: PrimerDialog.Header });

export default SafeDialog;

